module.exports = __webpack_public_path__ + "static/img/the-american-conservative.b585d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-american-conservative.png
// module id = XVGi
// module chunks = 0